import { RootState } from '../../../applicationStore';
import { ResourceSkillState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getResourceSkillState = (state: RootState): ResourceSkillState =>
  state.resourceSkill;

export const getResourceSkillLoader = createSelector(
  getResourceSkillState,
  (state): boolean => state.loading,
);

export const getResourceSkillData = createSelector(
  getResourceSkillState,
  (state): ResourceSkillState['data'] | null => state?.data || null,
);
